
<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact Message View"
      id="admin_view_contact_message_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        color="success"
        @click="read_message"
        v-if="parseInt(contact_us_message.is_read) == 0"
        :disabled="is_loading"
      >
        <v-icon left>mdi-pen</v-icon> Mark As Read
      </v-btn>
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
        @click="unread_message"
        v-if="parseInt(contact_us_message.is_read) == 1"
        :disabled="is_loading"
      >
        <v-icon left>mdi-pen</v-icon> Mark As UnRead
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="
          contact_us_message.first_name + ' ' + contact_us_message.last_name
        "
        :icon="'mdi-mail'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606720133/botswana%20services/website%20assets/contact-us-messages_yxy0ha.jpg'"
        :facts="view_header_facts"
        :description="contact_us_message.message"
      ></ViewHeader>
    </CardedDisplay>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminContactUsMessagesView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      contact_us_message: {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: "",
        is_read: 0,
        is_read_by_id: 0,
        read_on: 0,
        read_on_timestamp: 0,
        time_inserted: 0,
      },
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "From:",
          val:
            this.contact_us_message.email +
            ", " +
            this.contact_us_message.phone_number,
        },
        {
          text: "Date:",
          val: Utils.php_time_to_js_date_str(
            this.contact_us_message.time_inserted
          ),
        },
        {
          text: "Status:",
          val: this.contact_us_message.is_read == 0 ? "new" : "read",
        },
      ];
      return facts;
    },
  },
  methods: {
    load_item() {
      var msg_id = this.$route.params.id;
      this.$emit("on-show-loader");
      ServerClient.ContactUs.get_contact_message(
        {
          id: msg_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.contact_us_message = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading contact message details on admin",
            errors
          );
        }
      );
    },
    unread_message() {
      this.update_message({
        id: this.$route.params.id,
        is_read: 0,
        is_read_by_id: this.user.id,
        read_on: "1970-01-0",
        _time_read_on_timestamp: "1970-01-0",
      });
    },
    read_message() {
      this.update_message({
        id: this.$route.params.id,
        is_read: 1,
        is_read_by_id: this.user.id,
        _date_read_on: "",
        _now_read_on_timestamp: "",
      });
    },
    update_message(state) {
      this.$emit("on-show-loader");
      ServerClient.ContactUs.update_contact_message(
        state,
        (res) => {
          this.$emit("on-hide-loader");
          console.log("Updating contact us message success", res);
          this.load_item();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while updating contact us message details on admin",
            errors
          );
        }
      );
    },
  },
  mounted() {
    var msg_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "News Letter Subscription Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Messages",
          disabled: false,
          href: "/admin/contact_us_messages",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/contact_us_messages/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/contact_us_messages/list/view/" + msg_id,
        },
      ],
    });
    this.load_item();
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>